import request from '@/utils/request'

// 获取图片验证码
export function getCaptcha () {
  return request.get('/common/captcha')
}

// 根据密码登录
export function loginByPassword (data) {
  return request.post('/system/login', data)
}

// 登出
export function logout (data) {
  return request.post('/system/logout', data)
}

// 修改密码
export function updatePwd (data) {
  return request.post('/system/updatePwd', data)
}

// 获取已登录的用户信息
export function getUserInfo () {
  return request.get('/system/getUserInfo', {
    autoLogin: false
  })
}

// 访客来访配置
export function getVisitConfigDTO () {
  return request.get('/system/dictData/getVisitConfigDTO')
}

// 劳务来访配置
export function getLaborConfigDTO () {
  return request.get('/system/dictData/getLaborConfigDTO')
}

// 修改访客来访配置
export function updateVisitConfig (data) {
  return request.post('/system/dictData/updateVisitConfig', data)
}

// 修改劳务来访配置
export function updateLaborConfigDTO (data) {
  return request.post('/system/dictData/updateLaborConfigDTO', data)
}

// 分页查询系统用户
export function findAllList (data) {
  return request.post('/system/user/findAllList', data)
}

// 上传
export function upload (data) {
  return request.post('/public/upload', data)
}
